/**
 * Created by Ning Jiang on 2024-01-18.
 */

import {DeadwoodRipSymbol} from "../symbol/DeadwoodRipSymbol";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRipReelView} from "../reels/DeadwoodRipReelView";
import {DeadwoodRip} from "../DeadwoodRip";
import {gsap, TimelineLite} from "gsap";

export class XBetView {

    private _reel2View:PIXI.Sprite;
    private _reel3View:PIXI.Sprite;
    private _tl:TimelineLite | null;

    private _featureVisible:boolean;
    public set featureVisible(value:boolean) {
        this._featureVisible = value;
        this.updateView();
    }

    private _selectedIndex:number;
    public set selectedIndex(value:number) {
        this._selectedIndex = value;
        this.updateView();
    }

    constructor() {
        this._reel2View = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures("xbetbutton/xBet_active")[0]);
        this._reel2View.anchor.set(0.5);
        this._reel2View.position.set(DeadwoodRipReelView.REEL_AREAS[1].x, DeadwoodRipReelView.REEL_AREAS[1].y + DeadwoodRipSymbol.DEFAULT_HEIGHT * 2);
        this._reel2View.visible = false;
        // const rect2 = new PIXI.Graphics();
        // rect2.lineStyle(5, 0xFFbf44, 0.8);
        // rect2.drawRect(-DeadwoodRipSymbol.DEFAULT_WIDTH * 0.5, -DeadwoodRipSymbol.DEFAULT_HEIGHT * 2,
        //     DeadwoodRipSymbol.DEFAULT_WIDTH, DeadwoodRipSymbol.DEFAULT_HEIGHT * 4);
        // this._reel2View.addChild(rect2);

        this._reel3View = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures("xbetbutton/xBet_active")[0]);
        this._reel3View.anchor.set(0.5);
        this._reel3View.position.set(DeadwoodRipReelView.REEL_AREAS[2].x, DeadwoodRipReelView.REEL_AREAS[2].y + DeadwoodRipSymbol.DEFAULT_HEIGHT * 2);
        this._reel3View.visible = false;
        // const rect5 = new PIXI.Graphics();
        // rect5.lineStyle(5, 0xFFbf44, 0.8);
        // rect5.drawRect(-DeadwoodRipSymbol.DEFAULT_WIDTH * 0.5, -DeadwoodRipSymbol.DEFAULT_HEIGHT,
        //     DeadwoodRipSymbol.DEFAULT_WIDTH, DeadwoodRipSymbol.DEFAULT_HEIGHT * 2);
        // this._reel5View.addChild(rect5);

        DeadwoodRipLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this._reel2View, this._reel3View);
    }

    public updateView():void {
        this._reel3View.visible = this._featureVisible && this._selectedIndex === 2;
        this._reel2View.visible = this._featureVisible && this._selectedIndex > 0;
        DeadwoodRip.background.xbet = this._featureVisible && this._selectedIndex > 0;

        this.clearTl();
        if(DeadwoodRip.background.xbet) {
            this.startLoop();
        }
    }

    private startLoop():void {
        if(!DeadwoodRip.background.xbet) {
            this.clearTl();
            return;
        }
        const tl = new TimelineLite();
        tl.add(() => {
            this._reel2View.alpha = 0.3;
            this._reel3View.alpha = 0.3;
        });
        tl.add([
            gsap.to(this._reel2View, {duration : 4, alpha : 1, ease : "power3.out"}),
            gsap.to(this._reel3View, {duration : 4, alpha : 1, ease : "power3.out"})
        ]);
        tl.add([
            gsap.to(this._reel2View, {duration : 1, alpha : 0.3}),
            gsap.to(this._reel3View, {duration : 1, alpha : 0.3})
        ]);
        tl.add(() => {
            this.startLoop();
        });
        this._tl = tl;
    }

    private clearTl():void {
        if(this._tl) {
            if(this._tl.isActive()) {
                this._tl.paused();
                this._tl.kill();
            }
            this._tl = null;
        }
    }
}